import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../config";

const BookingForm = ({ hotelName }) => {
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        full_name: "",
        email: "",
        company: "",
        phone: "",
        hotel: "",
        start_date: "",
        end_date: "",
        guests: 1,
        notes: "",
    });

    const [submitted, setSubmitted] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            ...formData,
            hotel: hotelName,
        };

        try {
            const response = await fetch(`${API_BASE_URL}/api/bookings`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || "Booking failed");
            }

            // Save data to sessionStorage (using snake_case keys for consistency)
            sessionStorage.setItem(
                "bookingSuccessData",
                JSON.stringify({
                    full_name: formData.full_name,
                    hotel: hotelName,
                    start_date: formData.start_date,
                    end_date: formData.end_date,
                    email: formData.email,
                    phone: formData.phone,
                    guests: formData.guests,
                    notes: formData.notes,
                    company: formData.company,
                })
            );

            navigate("/booking/success");
        } catch (err) {
            console.error("Error submitting form:", err);
            navigate("/booking/error", { state: { message: err.message } });
        }
    };

    return (
        <div className="bg-white rounded-xl p-8 shadow-md border border-[#1D4E80]">
            <h2 className="text-2xl font-semibold text-primarymb-4">
                Enquire About a Booking
            </h2>

            {submitted ? (
                <p className="text-green-600 font-semibold">
                    Thank you! Your booking enquiry has been sent.
                </p>
            ) : (
                <form className="grid gap-4" onSubmit={handleSubmit}>
                    <div className="grid md:grid-cols-2 gap-4">
                        <input
                            type="text"
                            name="full_name"
                            placeholder="Full Name"
                            className="border p-2 rounded w-full"
                            value={formData.full_name}
                            onChange={handleChange}
                            required
                        />
                        <input
                            type="email"
                            name="email"
                            placeholder="Email Address"
                            className="border p-2 rounded w-full"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <input
                        type="text"
                        name="phone"
                        placeholder="Phone Number"
                        className="border p-2 rounded w-full"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                    />

                    <input
                        type="text"
                        name="company"
                        placeholder="Company Name (Optional)"
                        className="border p-2 rounded w-full"
                        value={formData.company}
                        onChange={handleChange}
                    />

                    <div className="grid md:grid-cols-2 gap-4">
                        <input
                            type="date"
                            name="start_date"
                            className="border p-2 rounded w-full"
                            value={formData.start_date}
                            onChange={handleChange}
                            required
                        />
                        <input
                            type="date"
                            name="end_date"
                            className="border p-2 rounded w-full"
                            value={formData.end_date}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <input
                        type="number"
                        name="guests"
                        placeholder="Number of Guests"
                        className="border p-2 rounded w-full"
                        value={formData.guests}
                        onChange={handleChange}
                        required
                        min={1}
                    />

                    <textarea
                        name="notes"
                        placeholder="Any notes or special requests"
                        rows="4"
                        className="border p-2 rounded w-full"
                        value={formData.notes}
                        onChange={handleChange}
                    ></textarea>

                    <button
                        type="submit"
                        className="bg-[#F29E38] text-[#023059] font-semibold px-6 py-3 rounded-full shadow hover:bg-opacity-90 transition"
                    >
                        Make a Reservation
                    </button>

                    <p className="text-xs text-[#888] mt-2">
                        * Your information is private and will never be shared without your
                        consent.
                    </p>
                </form>
            )}
        </div>
    );
};

export default BookingForm;
